import React from "react";
import "./../../Assets/css/Card.css";

export const Card = (props) => {
  return <div className="Card">{props.children}</div>;
};
